// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScanProfileWithRelationsSchema } from './ScanProfileRelationsSchema'
import type { ScanProfileWithRelations } from './ScanProfileRelationsSchema'
import { TailscaleNetworkWithRelationsSchema } from './TailscaleNetworkRelationsSchema'
import type { TailscaleNetworkWithRelations } from './TailscaleNetworkRelationsSchema'
import { AutomationScheduleSchema } from './AutomationScheduleSchema'
import type { AutomationSchedule } from './AutomationScheduleSchema'
import { ExternalNetworkScanWithRelationsSchema } from './ExternalNetworkScanRelationsSchema'
import type { ExternalNetworkScanWithRelations } from './ExternalNetworkScanRelationsSchema'
import { NetBlockWithRelationsSchema } from './NetBlockRelationsSchema'
import type { NetBlockWithRelations } from './NetBlockRelationsSchema'
import { SubnetWithRelationsSchema } from './SubnetRelationsSchema'
import type { SubnetWithRelations } from './SubnetRelationsSchema'
import { DomainWithRelationsSchema } from './DomainRelationsSchema'
import type { DomainWithRelations } from './DomainRelationsSchema'
import { HostWithRelationsSchema } from './HostRelationsSchema'
import type { HostWithRelations } from './HostRelationsSchema'
import { GatewayWithRelationsSchema } from './GatewayRelationsSchema'
import type { GatewayWithRelations } from './GatewayRelationsSchema'
import { NetworkServiceWithRelationsSchema } from './NetworkServiceRelationsSchema'
import type { NetworkServiceWithRelations } from './NetworkServiceRelationsSchema'
import { SoftwareWithRelationsSchema } from './SoftwareRelationsSchema'
import type { SoftwareWithRelations } from './SoftwareRelationsSchema'
import { ExternalNetworkProfileWithRelationsSchema } from './ExternalNetworkProfileRelationsSchema'
import type { ExternalNetworkProfileWithRelations } from './ExternalNetworkProfileRelationsSchema'
import { CveRetestJobWithRelationsSchema } from './CveRetestJobRelationsSchema'
import type { CveRetestJobWithRelations } from './CveRetestJobRelationsSchema'
import { ExternalNetworkCloudAccountPolicyWithRelationsSchema } from './ExternalNetworkCloudAccountPolicyRelationsSchema'
import type { ExternalNetworkCloudAccountPolicyWithRelations } from './ExternalNetworkCloudAccountPolicyRelationsSchema'
import { ExternalNetworkDnsZonePolicyWithRelationsSchema } from './ExternalNetworkDnsZonePolicyRelationsSchema'
import type { ExternalNetworkDnsZonePolicyWithRelations } from './ExternalNetworkDnsZonePolicyRelationsSchema'
import { StorageServiceWithRelationsSchema } from './StorageServiceRelationsSchema'
import type { StorageServiceWithRelations } from './StorageServiceRelationsSchema'
import { VhostBindingWithRelationsSchema } from './VhostBindingRelationsSchema'
import type { VhostBindingWithRelations } from './VhostBindingRelationsSchema'
import { ExternalNetworkWebAppCandidateWithRelationsSchema } from './ExternalNetworkWebAppCandidateRelationsSchema'
import type { ExternalNetworkWebAppCandidateWithRelations } from './ExternalNetworkWebAppCandidateRelationsSchema'
import { ExternalNetworkWebAppClusterWithRelationsSchema } from './ExternalNetworkWebAppClusterRelationsSchema'
import type { ExternalNetworkWebAppClusterWithRelations } from './ExternalNetworkWebAppClusterRelationsSchema'
import { ExternalNetworkSchema } from './ExternalNetworkSchema';

/////////////////////////////////////////
// EXTERNAL NETWORK RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkRelations = {
  scanProfile: ScanProfileWithRelations;
  tailscaleNetwork?: TailscaleNetworkWithRelations | null;
  schedule?: AutomationSchedule | null;
  executionSchedule?: AutomationSchedule | null;
  scans: ExternalNetworkScanWithRelations[];
  netblocks: NetBlockWithRelations[];
  subnets: SubnetWithRelations[];
  domains: DomainWithRelations[];
  hosts: HostWithRelations[];
  gateways: GatewayWithRelations[];
  networkServices: NetworkServiceWithRelations[];
  software: SoftwareWithRelations[];
  profile?: ExternalNetworkProfileWithRelations | null;
  cveRetestJobs: CveRetestJobWithRelations[];
  cloudAccountPolicies: ExternalNetworkCloudAccountPolicyWithRelations[];
  dnsZonePolicies: ExternalNetworkDnsZonePolicyWithRelations[];
  storageServices: StorageServiceWithRelations[];
  vhostBindings: VhostBindingWithRelations[];
  webAppCandidates: ExternalNetworkWebAppCandidateWithRelations[];
  webAppClusters: ExternalNetworkWebAppClusterWithRelations[];
};

export type ExternalNetworkWithRelations = z.infer<typeof ExternalNetworkSchema> & ExternalNetworkRelations

export const ExternalNetworkWithRelationsSchema: z.ZodType<ExternalNetworkWithRelations> = ExternalNetworkSchema.merge(z.object({
  scanProfile: z.lazy(() => ScanProfileWithRelationsSchema),
  tailscaleNetwork: z.lazy(() => TailscaleNetworkWithRelationsSchema).nullable(),
  schedule: z.lazy(() => AutomationScheduleSchema).nullable(),
  executionSchedule: z.lazy(() => AutomationScheduleSchema).nullable(),
  scans: z.lazy(() => ExternalNetworkScanWithRelationsSchema).array(),
  netblocks: z.lazy(() => NetBlockWithRelationsSchema).array(),
  subnets: z.lazy(() => SubnetWithRelationsSchema).array(),
  domains: z.lazy(() => DomainWithRelationsSchema).array(),
  hosts: z.lazy(() => HostWithRelationsSchema).array(),
  gateways: z.lazy(() => GatewayWithRelationsSchema).array(),
  networkServices: z.lazy(() => NetworkServiceWithRelationsSchema).array(),
  software: z.lazy(() => SoftwareWithRelationsSchema).array(),
  profile: z.lazy(() => ExternalNetworkProfileWithRelationsSchema).nullable(),
  cveRetestJobs: z.lazy(() => CveRetestJobWithRelationsSchema).array(),
  cloudAccountPolicies: z.lazy(() => ExternalNetworkCloudAccountPolicyWithRelationsSchema).array(),
  dnsZonePolicies: z.lazy(() => ExternalNetworkDnsZonePolicyWithRelationsSchema).array(),
  storageServices: z.lazy(() => StorageServiceWithRelationsSchema).array(),
  vhostBindings: z.lazy(() => VhostBindingWithRelationsSchema).array(),
  webAppCandidates: z.lazy(() => ExternalNetworkWebAppCandidateWithRelationsSchema).array(),
  webAppClusters: z.lazy(() => ExternalNetworkWebAppClusterWithRelationsSchema).array(),
}))